import Tool, {
  simpleToolButton,
  type IToolActionInput,
  type IToolEnabledInput,
} from './Tool';
import { hasEmbeddedContentBehaviors } from '../objects/guards';

class ToolOpenExternalEmbed extends Tool {
  static toolName = 'Open in new tab';

  static availableWhenLocked = true;

  static available({ selection, controller }: IToolEnabledInput): boolean {
    if (!selection) return false;

    const object = selection.firstObject?.() ?? selection;

    if (!object) return false;

    if (!controller.allowRecordLinking()) return false;

    return hasEmbeddedContentBehaviors(object);
  }

  static enabled({ selection }: IToolEnabledInput) {
    if (!selection) return false;

    const object = selection.firstObject?.() ?? selection;

    return object && hasEmbeddedContentBehaviors(object);
  }

  static action({ selection }: IToolActionInput) {
    const object = selection.firstObject?.() ?? selection;

    const url = object.externalContentUrl;

    window.open(url, '_blank', 'noopener noreferrer');
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolOpenExternalEmbed,
      'fa-regular fa-arrow-up-right-from-square'
    );
  }
}

export default ToolOpenExternalEmbed;
